import { create } from 'zustand';

const useCompanyConnectPopUpStore = create((set) => ({
  open: false,
  company: null,
  setOpen: (open, company) =>
    set(() => ({ open: open, company: company || null })),
}));

export default useCompanyConnectPopUpStore;
